const OctPhishingContestTranslations = {
  en: {
    heading1: "Know a lot about phishing?",

    heading2:
      "You may be good at detecting phishing emails, but can you create the perfect bait to hook users through phishing mail?",

    heading3:
      "Winners will be chosen, based on the following parameters:",

    cardText1:
      "The choice of recipe is yours… your phishing email can be a scam that relies on user’s fear and urgency or you may choose to pressurize them to make a payment or manipulate the user to divulge sensitive information.",

    cardText2:
      "Travel to the dark side and craft a seemingly genuine phishing email and stand a chance to win attractive prizes.",

    cardText3:
      "Play the Phishing Bait game to understand Phishing indicators. Make sure to include as many tell-tale signs of phishing as you can, the more sophisticated the better.",

    heading4: "",

    heading5: "",

    contestTags: "#DoYourPart #BeCyberSmart",
    socialMediaDisclaimerPrefix: 'DO NOT',
  socialMediaDisclaimerText: 'UPLOAD CONTEST ENTRIES ON SOCIAL MEDIA PLATFORMS.',

    guidelines: "Guidelines",

    listItem1:
      "Only ABI colleagues can participate in this contest",

    listItem2:
      "Only 1 entry per colleague",

    listItem3:
      "ABI Security awareness team reserves the right to use the creative content for internal communications or awareness purposes, with due credit being assigned to the author.",

    listItem4:
      "Submit your phishing email on the site.",

    listItem5:
      "Make sure to submit your entries before 30 October, 2026",

    listItem6:
      "30 October, 2026",

    number1:
      "Uniqueness and Creativity of Idea",

    number2:
      "Number of phishing indicators used in the email",

    formSubHeading: "SUBMIT YOUR",

    formHeading: "ENTRIES HERE",

    label1: "Employee ID",

    label2: "Upload File",

    label3: "Comment",

    plaeholder1:
      "Your Employee ID Here....",

    plaeholder2:
      "Your Comment Here....",

    submitbtn: "Submit",

    formFooterText:
      "Entries once submitted cannot be edited",

    guidelineButtonText:
      "For More Information Click Here",
  },

  es: {
    heading1:
      "¿Sabes mucho sobre phishing?",

    heading2:
      "Puede que seas bueno detectando correos electrónicos de phishing, pero ¿puedes crear el cebo perfecto para atraer a los usuarios mediante un correo de phishing?",

    heading3:
      "Los ganadores serán seleccionados según los siguientes parámetros:",

    cardText1:
      "Tú eliges el enfoque… tu correo de phishing puede ser una estafa que aproveche el miedo y la sensación de urgencia del usuario, o puedes intentar presionarlo para que realice un pago o manipularlo para que revele información confidencial.",

    cardText2:
      "Pasa al lado oscuro y crea un correo de phishing que parezca auténtico para tener la oportunidad de ganar atractivos premios.",

    cardText3:
      "Juega al juego Phishing Bait para comprender los indicadores de phishing. Asegúrate de incluir tantos indicios de phishing como sea posible; cuanto más sofisticados, mejor.",

    heading4: "",
     socialMediaDisclaimerPrefix: 'NO',
  socialMediaDisclaimerText: 'SUBAS LAS PARTICIPACIONES DEL CONCURSO A PLATAFORMAS DE REDES SOCIALES.',

    heading5: "",

    contestTags:
      "#HazTuParte #SéCiberInteligente",

    guidelines: "Directrices",

    listItem1:
      "Solo los compañeros de ABI pueden participar en este concurso.",

    listItem2:
      "Solo se permite una participación por compañero.",

    listItem3:
      "El equipo de concienciación sobre seguridad de ABI se reserva el derecho de utilizar el contenido creativo para comunicaciones internas o fines de concienciación, dando el debido crédito al autor.",

    listItem4:
      "Envía tu correo de phishing a través del sitio web.",

    listItem5:
      "Asegúrate de enviar tu participación antes del 30 de octubre de 2026.",

    listItem6:
      "30 de octubre de 2026",

    number1:
      "Originalidad y creatividad de la idea",

    number2:
      "Número de indicadores de phishing utilizados en el correo electrónico",

    formSubHeading: "ENVÍA TUS",

    formHeading: "PARTICIPACIONES AQUÍ",

    label1: "Identificación del empleado",

    label2: "Subir archivo",

    label3: "Comentario",

    plaeholder1:
      "Introduce aquí tu identificación de empleado....",

    plaeholder2:
      "Introduce aquí tu comentario....",

    submitbtn: "Enviar",

    formFooterText:
      "Las participaciones no se pueden editar una vez enviadas.",

    guidelineButtonText:
      "Para obtener más información, haz clic aquí",
  },

  pt: {
    heading1:
      "Você sabe muito sobre phishing?",

    heading2:
      "Você pode ser bom em detectar e-mails de phishing, mas consegue criar a isca perfeita para atrair usuários por meio de um e-mail de phishing?",

    heading3:
      "Os vencedores serão escolhidos com base nos seguintes parâmetros:",

    cardText1:
      "A escolha da abordagem é sua… seu e-mail de phishing pode ser um golpe que explore o medo e a urgência do usuário, ou você pode optar por pressioná-lo a fazer um pagamento ou manipulá-lo para divulgar informações confidenciais.",

    cardText2:
      "Vá para o lado sombrio e crie um e-mail de phishing aparentemente legítimo para ter a chance de ganhar prêmios atrativos.",

    cardText3:
      "Jogue o jogo Phishing Bait para entender os indicadores de phishing. Certifique-se de incluir o máximo possível de sinais de phishing; quanto mais sofisticados, melhor.",

    heading4: "",

    heading5: "",

    contestTags:
      "#FaçaSuaParte #SejaCiberInteligente",

    guidelines: "Diretrizes",

    listItem1:
      "Somente colegas da ABI podem participar deste concurso.",

    listItem2:
      "É permitida apenas uma participação por colega.",

    listItem3:
      "A equipe de conscientização de segurança da ABI reserva-se o direito de utilizar o conteúdo criativo para comunicações internas ou fins de conscientização, dando o devido crédito ao autor.",

    listItem4:
      "Envie seu e-mail de phishing pelo site.",

    listItem5:
      "Certifique-se de enviar sua participação antes de 30 de outubro de 2026.",

    listItem6:
      "30 de outubro de 2026",

    number1:
      "Originalidade e criatividade da ideia",

    number2:
      "Número de indicadores de phishing utilizados no e-mail",

    formSubHeading: "ENVIE SUAS",

    formHeading: "INSCRIÇÕES AQUI",

    label1: "ID do funcionário",

    label2: "Carregar arquivo",

    label3: "Comentário",

    plaeholder1:
      "Digite aqui o ID do funcionário....",

    plaeholder2:
      "Digite aqui seu comentário....",

    submitbtn: "Enviar",

    formFooterText:
      "As inscrições não podem ser editadas após o envio.",

    guidelineButtonText:
      "Para mais informações, clique aqui",
       socialMediaDisclaimerPrefix: 'NÃO',
  socialMediaDisclaimerText: 'PUBLIQUE AS PARTICIPAÇÕES DO CONCURSO EM PLATAFORMAS DE REDES SOCIAIS.'
  },

  zh: {
    heading1:
      "你对网络钓鱼了解很多吗？",

    heading2:
      "你可能很擅长识别网络钓鱼邮件，但你能否设计出完美的诱饵，通过网络钓鱼邮件吸引用户？",

    heading3:
      "获胜者将根据以下参数进行评选：",

    cardText1:
      "由你选择方式……你的网络钓鱼邮件可以利用用户的恐惧和紧迫感进行诈骗，也可以通过施压让用户付款，或诱导用户泄露敏感信息。",

    cardText2:
      "进入黑暗面，制作一封看似真实的网络钓鱼邮件，即有机会赢取丰厚奖品。",

    cardText3:
      "玩 Phishing Bait 游戏，了解网络钓鱼指标。确保尽可能多地加入网络钓鱼的典型迹象；越巧妙、越复杂越好。",

    heading4: "",

    heading5: "",

    contestTags:
      "#尽你的一份力 #做网络安全达人",

    guidelines: "参赛指南",
      socialMediaDisclaimerPrefix: '请勿',
  socialMediaDisclaimerText: '将竞赛作品上传到社交媒体平台。',


    listItem1:
      "只有 ABI 同事可以参加本次比赛。",

    listItem2:
      "每位同事仅限提交 1 份参赛作品。",

    listItem3:
      "ABI 安全意识团队保留将创意内容用于内部沟通或安全意识宣传的权利，并会注明作者信息。",

    listItem4:
      "请在网站上提交您的网络钓鱼邮件。",

    listItem5:
      "请确保在 2026 年 10 月 30 日之前提交您的参赛作品。",

    listItem6:
      "2026 年 10 月 30 日",

    number1:
      "创意的独特性与创造力",

    number2:
      "邮件中使用的网络钓鱼指标数量",

    formSubHeading: "提交您的",

    formHeading: "参赛作品",

    label1: "员工编号",

    label2: "上传文件",

    label3: "评论",

    plaeholder1:
      "请输入您的员工编号....",

    plaeholder2:
      "请输入您的评论....",

    submitbtn: "提交",

    formFooterText:
      "参赛作品提交后将无法编辑。",

    guidelineButtonText:
      "如需了解更多信息，请点击这里",
  },
};

export default OctPhishingContestTranslations;